const validateFieldFilters = (fieldFilters, operator, inMemoryFields, maxFilters = 0) => {
  const existingFieldNames = /* @__PURE__ */ new Set();
  const allFieldsHasSameInMemoryFlag = fieldFilters.every(({ field_name }) => inMemoryFields.has(field_name)) || fieldFilters.every(({ field_name }) => !inMemoryFields.has(field_name));
  const errors = fieldFilters.map((filter) => {
    const filterErrors = {};
    if (!filter.field_name) {
      filterErrors.field_name = "Field name is required";
    }
    if (filter.field_name && operator === "AND") {
      if (existingFieldNames.has(filter.field_name)) {
        filterErrors.field_name = "There can only be one filter per field";
      }
      existingFieldNames.add(filter.field_name);
    }
    if (!filter.value) {
      filterErrors.value = "Value is required";
    }
    if (operator === "OR" && !allFieldsHasSameInMemoryFlag && inMemoryFields.has(filter.field_name)) {
      filterErrors.field_name = "Cannot use OR filtering when both in-memory filters and iceberg filters are present.";
    }
    if (maxFilters && fieldFilters.length > maxFilters) {
      filterErrors.field_name = `You can add only ${maxFilters} filters`;
    }
    return Object.entries(filterErrors).length > 0 ? filterErrors : null;
  });
  const filteredErrors = errors.filter((error) => !!error);
  return filteredErrors.length > 0 ? errors : [];
};
export default validateFieldFilters;
